import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { DEAL_JOURNEY_ANALYTICS_READ, JOURNEY_ANALYTICS_READ_SCOPE } from 'reporting-data/constants/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
const JourneyDropoffEditor = ({
  report,
  onChange
}) => {
  const journeyReport = report.toJS();
  const includeDropoffs = journeyReport.journeyQuery.includeDropoffs;
  const isSankey = journeyReport.chartType === 'SANKEY';
  const updateReportDropoff = useCallback(() => {
    const newDropoff = isSankey ? !includeDropoffs : false;
    const updatedReport = report.setIn(['journeyQuery', 'includeDropoffs'], newDropoff);
    onChange(updatedReport);
  }, [isSankey, includeDropoffs, report, onChange]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingLabels.dropoff.disable"
    }),
    disabled: isSankey,
    placement: "right",
    children: /*#__PURE__*/_jsx(Checkbox, {
      size: "sm",
      checked: includeDropoffs && isSankey,
      onChange: updateReportDropoff,
      disabled: !isSankey,
      marginBlockStart: "300",
      "data-test-id": "journey-dropoff-editor",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.dropoff.label"
      })
    })
  });
};
JourneyDropoffEditor.isUsableForReport = (report, gates, scopes) => isJourneyReport(report) && (scopes.includes(DEAL_JOURNEY_ANALYTICS_READ) || scopes.includes(JOURNEY_ANALYTICS_READ_SCOPE));
export default JourneyDropoffEditor;